import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams,  } from 'react-router-dom';

import LoginPanel from './LoginPanels/LoginPanel';
import PwChangePanel from './LoginPanels/PwChangePanel';
import SignUpPanel from './LoginPanels/SignUpPanel'; 
import FindIdPasswordPanel from './LoginPanels/FindIdPasswordPanel';
import MessagePanel from './LoginPanels/MessagePanel';

import { useSelector } from 'react-redux';

import { showToast } from './Common/Messages';
import { readLoginSession } from './libs/useSessionValidation';

const Login = () => {
    const LoginStates = useSelector((state) => state.login);
    const loginSession = readLoginSession();

    const [companyList, setCompanyList] = useState('');
    const [deptList, setDeptList] = useState('');

    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    useEffect(() => {
        getCompanyAndDeptList();
        if (params.panel != '' && params.panel != undefined) {
            setPanelType(params.panel);
            window.history.replaceState(null, '', '/Login')
        }
    }, []);
    const getCompanyAndDeptList = async () => {
        fetch('api/User/GetCompanyAndDeptListQuery?userId=-1', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        }).then((response) => response.json())
            .then((data) => {
                if (Object.keys(data).length != 0) {
                    let companyList = data.table ?? '', deptList = data.table1 ?? '';
                    setCompanyList(companyList);
                    setDeptList(deptList);
                }
            });
    };

    const [panelType, setPanelType] =useState('');
    const [result, setResult] =useState('');
    const [message, setMessage] =useState('');
    const canNavigate = Boolean(LoginStates.sessionId && LoginStates.userId && (
        result === 'Success Login' || loginSession?.sessionId === LoginStates.sessionId
    ));
    const returnPath = location.state?.pathName || '/';

    useEffect(() => {
        if (!canNavigate) return;
        localStorage.setItem('loginsession', JSON.stringify({ userId: LoginStates.userId, sessionId: LoginStates.sessionId }));
        const path = returnPath.split('/')[1] === 'Login' ? '/' : returnPath;
        navigate(path, { replace: true });
    }, [canNavigate, LoginStates.userId, LoginStates.sessionId, returnPath, navigate]);

    useEffect(() => {
        if (!message) return;
        if (result === 'Success Login' || result === 'Success Changing Password') showToast('success', message);
        else if (result === 'Fail Login') showToast('danger', message, 3000);
        else if (result === 'Change Password') showToast('warning', message, 3000);
    }, [result, message]);
    //렌더링될 때마다 돌며 패널을 바꿔주는 함수
    const actionResult = () => {
        if (canNavigate) return 'doMain';
        if(loginSession != null) {
            if (!LoginStates.sessionId) return 'checkingSession';
            return 'doMain';
        }
        if (result == '') {
            //result 값이 없는 경우는 화면 이벤트에 의한 Action
            return panelType;
        }
        else {
            if (result == 'Success Login') {
                return 'loginAgain';
            }
            else {
                //callBack에 의한 로그인 실패 로직.
                if (result == 'Fail Login') {
                    return 'loginAgain';
                }
                else if (result == 'Change Password') {
                    return 'changePassword';
                }
                else if (result == 'Over Failed Count') {                    
                    return 'showMessage';
                }
                else if (result == 'Success Finding') {
                    return 'showMessage';
                }
                else if (result == 'Success Changing Password') {
                    return 'loginAgain';
                }
                else
                {   
                    return 'showMessage';
                }
            }
        }
    };

    const panelChange = (panelType) => {
        if (panelType === 'checkingSession') {
            return <p role="status">로그인 상태를 확인하고 있습니다.</p>;
        }
        if (panelType == '' | panelType.toLowerCase() == 'loginagain') {
            return (
                <LoginPanel setPanelType={setPanelType} setResult={setResult} setMessage={setMessage} />
            );
        }
        else if (panelType.toLowerCase() == 'changepassword') {
            return (
                <PwChangePanel setPanelType={setPanelType} setResult={setResult} setMessage={setMessage}/>
            );
        }
        else if (panelType.toLowerCase() == 'signup') {
            return (
                <SignUpPanel companyList={companyList} deptList={deptList} setPanelType={setPanelType} setResult={setResult} setMessage={setMessage}/>
            );
        }
        else if (panelType.toLowerCase() == 'showmessage') {
            return (
                <MessagePanel setPanelType={setPanelType} />
            );
        }
        else if (panelType.toLowerCase() == 'findpassword') {
            return (
                <FindIdPasswordPanel setPanelType={setPanelType} setResult={setResult} setMessage={setMessage}/>
            );
        }
        else if (panelType.toLowerCase() == 'findinfo') {
            return (
                <FindIdPasswordPanel setPanelType={setPanelType} setResult={setResult} setMessage={setMessage}/>
            );
        }
        else if (panelType.toLowerCase() == 'domain') {
            return <p role="status">로그인 후 이동하고 있습니다.</p>;
        }
        else {
            return (
                <div>No Panel</div>
            );
        }

    };
    const doAction = actionResult();
    
    return (
        <Fragment>
            {panelChange(doAction)}
        </Fragment>
    );
};

export default Login;
